import { render, staticRenderFns } from "./BModalCentral.vue?vue&type=template&id=2bf53022&scoped=true"
import script from "./BModalCentral.vue?vue&type=script&lang=js"
export * from "./BModalCentral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.43_css-loader@6.11.0_webpack@5.111.1_clean-css_fb1138f4c37e5532632f307186fea031/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf53022",
  null
  
)

export default component.exports